import type { SessionSaccoUser } from "../types/session";

type SaccoUserPatcher = (saccoUser: SessionSaccoUser) => void;

let patchSaccoUser: SaccoUserPatcher | null = null;

export function registerSaccoUserPatcher(patcher: SaccoUserPatcher | null) {
  patchSaccoUser = patcher;
}

export function updateSessionSaccoUser(saccoUser: SessionSaccoUser) {
  patchSaccoUser?.(saccoUser);
}
